module.exports = __webpack_public_path__ + "static/img/u301.e9c51f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u301.png
// module id = xFfj
// module chunks = 1